import { default as BackButton } from "./BackButton";
import { default as Group, type NavbarGroupProps } from "./Group";
import { default as Logo, type NavbarLogoProps } from "./Logo";
import { default as Menu } from "./Menu";
import { type NavbarPageTitleProps, default as PageTitle } from "./PageTitle";
import { type NavbarRootProps, default as Root } from "./Root";

export const Navbar = {
  Root,
  Group,
  PageTitle,
  BackButton,
  Logo,
  Menu,
};

export const NavbarRoot = Root;
export const NavbarGroup = Group;
export const NavbarPageTitle = PageTitle;
export const NavbarBackButton = BackButton;
export const NavbarLogo = Logo;
export const NavbarAppAndToolMenu = Menu;

export type { NavbarGroupProps, NavbarLogoProps, NavbarPageTitleProps, NavbarRootProps };
